<template>
  <div class="home">
      <ProfilPage class="marginal" ></ProfilPage>
  </div>
</template>

<script>
import ProfilPage from '@/components/ProfilPage.vue';
export default {
  name: 'profil',
  components: {
    ProfilPage
  }
}
</script>